module.exports = __webpack_public_path__ + "static/media/blog9-image.9b99c6fb.jpg";